import { TbLockBolt } from "react-icons/tb";
import "./customPayment.css";
import { FaBolt } from "react-icons/fa6";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import axios from "../axios";
import { ColorRing } from "react-loader-spinner";
import { notifyDanger } from "../action/customFn";
import Lottie from "lottie-react";
import ShieldLottie from "../../public/metb_shield_lottie.json";
import { MdErrorOutline } from "react-icons/md";

function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

export default function CustomPaymentPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [loading, setLoading] = useState(true);
  const [waitforVerification, setWaitForVerification] = useState(false);
  const [verificationSuccess, setVerificationSuccess] = useState(false);
  const [error, setError] = useState(false);

  const [paymentData, setPaymentData] = useState(null);
  const [fullName, setFullName] = useState("");

  const navigate = useNavigate();

  const loadScript = useCallback((src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;

      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);

      document.body.appendChild(script);
    });
  }, []);

  const RazorPayBtn2 = async (
    amount,
    currency,
    orderId,
    email,
    key_id
  ) => {
    try {
      const scp_r = await loadScript(
        "https://checkout.razorpay.com/v1/checkout.js"
      );

      if (!scp_r) {
        window.alert("Razorpay Script Failed to load");
        return;
      }

      const notesObj = {
        email,
        fullName,
      };

      const notes = JSON.stringify(notesObj);

      const options = {
        key: key_id,
        amount,
        currency,
        order_id: orderId,

        handler: async function (response) {
          try {
            if (response.razorpay_payment_id) {
              setWaitForVerification(true);

              const verificationResponse = await axios.post(
                "/payment/verify",
                {
                  orderId,
                  response,
                  token,
                }
              );

              if (verificationResponse.status === 200) {
                setVerificationSuccess(true);
              }
            }
          } catch (err) {
            console.log(err);
            notifyDanger("Payment verification failed");
          } finally {
            setWaitForVerification(false);
          }
        },

        prefill: {
          name: fullName,
          email,
        },

        description: notes,
        notes: notes,

        theme: {
          color: "#2f2f2f",
        },
      };

      const razorpayObject = new window.Razorpay(options);

      razorpayObject.on("payment.failed", function () {
        notifyDanger("Payment Failed");
      });

      razorpayObject.open();
    } catch (err) {
      console.log(err);
    }
  };

  async function verifyTokenAndGetPaymentInformation() {
    try {
      setLoading(true);
      setError(false);

      await sleep(1500);

      const response = await axios.post(
        "/dashboard-data/check-ext-link-xnmrph-pay",
        {
          token,
        }
      );

      if (response.status === 200 && response.data.success) {
        const {
          orderId,
          email,
          amount,
          currency,
          key_id,
          courseName,
        } = response.data;

        setPaymentData({
          orderId,
          email,
          amount,
          currency,
          key_id,
          courseName,
        });
      }
    } catch (error) {
      console.log(error);
      setError(true);
    } finally {
      setLoading(false);
    }
  }

  const handleProceedToPayment = async () => {
    if (!fullName.trim()) {
      notifyDanger("Please enter your full name");
      return;
    }

    await RazorPayBtn2(
      paymentData.amount,
      paymentData.currency,
      paymentData.orderId,
      paymentData.email,
      paymentData.key_id
    );
  };

  useEffect(() => {
    verifyTokenAndGetPaymentInformation();
  }, []);

  return (
    <div className="custom-pay-parent">
      <div className="custom-pay-nav">
        <img
          src="/Metbrains_logo_shadow.png"
          alt="logo"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        />

        <div className="tray">
          <FaBolt style={{ color: "oklch(78.9% 0.154 211.53)" }} />
          <span>Secure, Fast, Reliable</span>
        </div>
      </div>

      <div className="custom-pay-content">
        <div className="custom-pay-card">
          {!token && (
            <div className="custom">
              <p>Invalid or Corrupt Token!</p>
            </div>
          )}

          {loading && (
            <div className="custom-pay-loader-hldr">
              <Lottie
                animationData={ShieldLottie}
                style={{
                  width: "260px",
                }}
                loop
              />

              <p
                style={{
                  color: "#000",
                  fontSize: "20px",
                  fontWeight: 600,
                }}
              >
                Securely Initializing Payment
              </p>
            </div>
          )}

          {error && (
            <div className="custom-pay-loader-hldr">
              <MdErrorOutline color="red" size={44} />

              <p
                style={{
                  color: "#000",
                  fontSize: "20px",
                }}
              >
                Invalid or Corrupt Token
              </p>

              <p
                style={{
                  color: "#000",
                  textAlign: "center",
                }}
              >
                Please contact the support team,
                <br />
                or make payment through the website.
              </p>
            </div>
          )}

          {waitforVerification && (
            <div className="custom-pay-loader-hldr">
              <ColorRing visible height="80" width="80" />

              <p
                style={{
                  color: "#000",
                  fontSize: "20px",
                  fontWeight: 600,
                }}
              >
                Verifying Payment
              </p>
            </div>
          )}

          {verificationSuccess && (
            <div
              style={{
                textAlign: "center",
                padding: "40px",
              }}
            >
              <TbLockBolt
                size={60}
                color="#16a34a"
              />

              <h2
                style={{
                  marginTop: "20px",
                }}
              >
                Payment Successful
              </h2>

              <p>
                Your payment has been verified successfully.
              </p>
            </div>
          )}

          {!loading &&
            !error &&
            !waitforVerification &&
            !verificationSuccess &&
            paymentData && (
              <div
                style={{
                  width: "100%",
                  maxWidth: "550px",
                  margin: "0 auto",
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  color:"black"
                }}
              >
                <div
                  style={{
                    textAlign: "center",
                  }}
                >
                  <TbLockBolt
                    size={48}
                    color="#16a34a"
                  />

                  <h2
                    style={{
                      marginTop: "12px",
                      marginBottom: "8px",
                    }}
                  >
                    Secure Payment
                  </h2>

                  <p
                    style={{
                      color: "#6b7280",
                    }}
                  >
                    Please review your enrollment details before
                    proceeding to payment.
                  </p>
                </div>

                <div
                  style={{
                    background: "#fff",
                    border: "1px solid #e5e7eb",
                    borderRadius: "16px",
                    padding: "24px",
                    boxShadow:
                      "0 10px 30px rgba(0,0,0,0.05)",
                  }}
                >
                  {paymentData.courseName && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        paddingBottom: "16px",
                        marginBottom: "16px",
                        borderBottom:
                          "1px solid #f1f5f9",
                      }}
                    >
                      <span>Course</span>

                      <strong>
                        {paymentData.courseName}
                      </strong>
                    </div>
                  )}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingBottom: "16px",
                      marginBottom: "16px",
                      borderBottom:
                        "1px solid #f1f5f9",
                    }}
                  >
                    <span>Email</span>

                    <strong>
                      {paymentData.email}
                    </strong>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingBottom: "16px",
                      marginBottom: "16px",
                      borderBottom:
                        "1px solid #f1f5f9",
                    }}
                  >
                    <span>Currency</span>

                    <strong>
                      {paymentData.currency}
                    </strong>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>Amount</span>

                    <strong
                      style={{
                        fontSize: "18px",
                      }}
                    >
                      {paymentData.currency}{" "}
                      {paymentData.amount}
                    </strong>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  <label
                    style={{
                      fontWeight: "600",
                    }}
                  >
                    Full Name
                  </label>

                  <input
                    type="text"
                    placeholder="Enter your full name"
                    value={fullName}
                    onChange={(e) =>
                      setFullName(e.target.value)
                    }
                    style={{
                      height: "54px",
                      border:
                        "1px solid #d1d5db",
                      borderRadius: "12px",
                      padding: "0 16px",
                      fontSize: "15px",
                    }}
                  />
                </div>

                <button
                  onClick={handleProceedToPayment}
                  style={{
                    height: "56px",
                    border: "none",
                    borderRadius: "12px",
                    background: "#111827",
                    color: "#fff",
                    fontSize: "16px",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  Continue To Payment
                </button>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "8px",
                    color: "#16a34a",
                    fontSize: "14px",
                  }}
                >
                  <TbLockBolt />
                  <span>
                    Protected by secure payment encryption
                  </span>
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  );
}